import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  faInstagram,
  faFacebook,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import logo from "../assets/logo.png";

const FooterContainer = styled.footer`
  background-color: #1a5f7a;
  color: white;
  padding: 60px 0 30px;
`;

const FooterContent = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 30px;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 40px;
  }
`;

const FooterLogo = styled.img`
  height: 100px;
  margin-bottom: 20px;

  @media (max-width: 576px) {
    height: 90px;
  }
`;

const FooterAbout = styled.div`
  flex: 2;
  max-width: 400px;
`;

const FooterLinks = styled.div`
  flex: 1;
`;

const FooterContact = styled.div`
  flex: 1;
`;

const FooterHeading = styled.h4`
  margin-bottom: 20px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -10px;
    width: 30px;
    height: 2px;
    background-color: #57c5b6;
  }
`;

const FooterLinksList = styled.ul`
  list-style: none;
  padding-left: 0;
`;

const FooterLinkItem = styled.li`
  margin-bottom: 10px;
`;

const FooterLink = styled(Link)`
  color: #ddd;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    color: white;
    padding-left: 5px;
  }
`;

const ContactInfo = styled.div`
  margin-bottom: 15px;
  display: flex;
  align-items: center;
`;

const ContactIcon = styled.span`
  margin-right: 10px;
  color: #57c5b6;
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 20px;
`;

const SocialIcon = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background-color: #57c5b6;
    transform: translateY(-3px);
  }
`;

const FooterBottom = styled.div`
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.9rem;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterAbout>
          <FooterLogo src={logo} alt="Skyline Terrace Logo" />
          <p>
            Skyline Terrace Apartments is the perfect blend of modern living and
            serene surroundings. Experience comfort like never before.
          </p>
        </FooterAbout>

        <FooterLinks>
          <FooterHeading>Quick Links</FooterHeading>
          <FooterLinksList>
            <FooterLinkItem>
              <FooterLink to="/">Home</FooterLink>
            </FooterLinkItem>
            <FooterLinkItem>
              <FooterLink to="/about">About</FooterLink>
            </FooterLinkItem>
            <FooterLinkItem>
              <FooterLink to="/apartments">Apartments</FooterLink>
            </FooterLinkItem>
            <FooterLinkItem>
              <FooterLink to="/join">Join</FooterLink>
            </FooterLinkItem>
            <FooterLinkItem>
              <FooterLink to="/contact">Contact</FooterLink>
            </FooterLinkItem>
          </FooterLinksList>
        </FooterLinks>

        <FooterContact>
          <FooterHeading>Contact Us</FooterHeading>
          <ContactInfo>
            <ContactIcon>
              <FontAwesomeIcon icon={faPhone} />
            </ContactIcon>
            <span>+92-303-0312222</span>
          </ContactInfo>
          <ContactInfo>
            <ContactIcon>
              <FontAwesomeIcon icon={faEnvelope} />
            </ContactIcon>
            <span>terraceskyline1@gmail.com</span>
          </ContactInfo>
          <SocialIcons>
            <SocialIcon
              href="https://www.instagram.com/skylineterracegaliyat?igsh=anVrd2Y0cXJrYjg3"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </SocialIcon>
            <SocialIcon
              href="https://www.facebook.com/profile.php?id=61575225360796&mibextid=ZbWKwL"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faFacebook} />
            </SocialIcon>
            <SocialIcon
              href="https://wa.me/+923030312222"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faWhatsapp} />
            </SocialIcon>
          </SocialIcons>
        </FooterContact>
      </FooterContent>

      <FooterBottom>
        &copy; {new Date().getFullYear()} Skyline Terrace. All rights reserved.
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;
